import Vue from 'vue';
import { forEach } from 'lodash';
let Toaster = /** @class */ (() => {
    class Toaster {
        ShowApiError(response) {
            let message = '';
            forEach(response.errorMessages, (item) => {
                message += item.message;
                message + '. ';
            });
            // A body the API can't bind (e.g. a date it can't convert) is rejected before the controller with a
            // validation problem response - { title, errors: { "$.dueDate": [...] } } - which has no errorMessages
            if (!message) {
                message = this.validationProblemMessage(response);
            }
            Vue.$toast.error(message, {
                timeout: 4000,
            });
        }
        // "Due Date is invalid." per field ("$.dueDate" / "$.items[0].dueDate" -> "Due Date"), else the title
        validationProblemMessage(response) {
            const fields = [];
            Object.keys((response && response.errors) || {}).forEach((key) => {
                // Only JSON paths name a field; other keys (e.g. the action's parameter name) fall back to the title
                if (key.indexOf('$.') !== 0) {
                    return;
                }
                const name = key.replace(/\[\d+\]/g, '').split('.').pop() || '';
                const label = name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
                if (label && label !== '$' && fields.indexOf(label) === -1) {
                    fields.push(label);
                }
            });
            if (fields.length) {
                return fields.map((label) => `${label} is invalid.`).join(' ');
            }
            return (response && response.title) || 'The request could not be processed.';
        }
        ShowApiSuccess(response) {
            let message = '';
            forEach(response.successMessages, (item) => {
                message += item;
                message + '<br/>';
            });
            Vue.$toast.success(message, {
                timeout: 4000,
            });
        }
        ShowError(message) {
            Vue.$toast.error(message, {
                timeout: 4000,
            });
        }
        ShowWarning(message) {
            Vue.$toast.warning(message, {
                timeout: 4000,
            });
        }
        ShowSuccess(message) {
            Vue.$toast.success(message, {
                timeout: 4000,
            });
        }
        ShowProgress(message, title) {
            Vue.$toast.info(message, {
                timeout: 4000,
            });
        }
    }
    Toaster.vueInstance = new Vue({});
    return Toaster;
})();
export { Toaster };
export const toaster = new Toaster();
